// extracted by mini-css-extract-plugin
export default {"addedbtn":"LoadingAnimation_addedbtn__PBY9D","btnText":"LoadingAnimation_btnText__D8g2I","addedBtnIcon":"LoadingAnimation_addedBtnIcon__JeLiQ"};